export default {
  title: "Besoin d'aide ?",

  description:
    'Nos experts sont à votre écoute pour affiner votre projet. Nous vous accompagnons avec des conseils sur-mesure !',

  trigger: "J'échange avec un expert",

  contact: {
    title: 'Je contacte Hellio',
    tag: 'Appel gratuit',
    description:
      'Nos experts sont disponibles du lundi au vendredi, de 9h à 18h',
  },

  tel: '01 44 56 00 00',
};
